export default __webpack_public_path__ + "static/media/two.d55ce14f.svg";